import React from 'react';
import DataTable from 'react-data-table-component';
import { motion } from "framer-motion";

const AppDataTable = ({
    appFilteredData,
    admin,
    status,
    changeAppStatus,
    DownloadAppRejectionAttachment,
    openEditModal,
    openDeleteModal
}) => {
    const columns = [
        {
            name: "App Id",
            selector: row => row.AppId
        },
        ...(admin ? [{
            name: "Publisher Name",
            selector: row => row.PublisherName
        }] : []),
        {
            name: "Name",
            selector: row => row.Name
        },
        {
            name: "URL",
            selector: row => row.Url
        },
        {
            name: "Status",
            cell: (row) => (
                admin ? (
                    <select
                        className={`border m-2 p-2 rounded-full ${row.ApprovalStatus === status.GettingReady ? "text-yellow-400 focus:ring-yellow-300" :
                                row.ApprovalStatus === status.Approved ? "text-green-700 focus:ring-green-500" :
                                    "text-red-700 focus:ring-red-500"
                            } bg-transparent focus:ring-2 focus:outline-none shadow-sm transition-all duration-300`}
                        value={row.ApprovalStatus}
                        onChange={(e) => changeAppStatus(e, row.Id)}
                    >
                        <option className="text-yellow-400" value={status.GettingReady}>
                            Getting Ready
                        </option>
                        <option className="text-green-700" value={status.Approved}>
                            Approved
                        </option>
                        <option className="text-red-700" value={status.Disapproved}>
                            Disapproved
                        </option>
                    </select>
                ) : (
                    <button
                        type="button"
                        className={`${row.ApprovalStatus === status.Approved ?
                                "text-green-700 hover:text-white border border-green-700 hover:bg-green-800" :
                                row.ApprovalStatus === status.GettingReady ?
                                    "text-yellow-400 hover:text-white border border-yellow-400 hover:bg-yellow-500" :
                                    "text-red-700 hover:text-white border border-red-700 hover:bg-red-800"
                            } focus:ring-4 focus:outline-none font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 mt-2`}
                    >
                        {row.ApprovalStatus}
                    </button>
                )
            )
        },
        // In the actions column cell:
        {
            name: "Actions",
            cell: (row) => (
                <div className="flex items-center space-x-2">
                    <button
                        onClick={() => openEditModal(row)}
                        className="bg-blue-500 px-3 py-1 text-white rounded flex-shrink-0"
                    >
                        Edit
                    </button>
                    {admin && (
                        <button
                            onClick={() => openDeleteModal(row)}
                            className="bg-red-500 px-3 py-1 text-white rounded flex-shrink-0"
                        >
                            Delete
                        </button>
                    )}
                </div>
            )
        }
    ];


    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
        >
            <DataTable
                columns={columns}
                data={appFilteredData}
                pagination
                highlightOnHover
                striped
                responsive
                className="min-w-full bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300"
            />
        </motion.div>
    );
};

export default AppDataTable;